export default "__VITE_ASSET__32aa14ad__"